import { PushNotifications } from "@capacitor/push-notifications";
import { isNative, platformName } from "./platform";
import { apiUrl } from "./api";

export async function registerForPush() {
  if (!isNative()) return { ok: false, reason: "not-native" };

  const perm = await PushNotifications.checkPermissions();
  let status = perm.receive;
  if (status === "prompt" || status === "prompt-with-rationale") {
    const req = await PushNotifications.requestPermissions();
    status = req.receive;
  }
  if (status !== "granted") {
    return { ok: false, reason: "denied" };
  }

  return new Promise((resolve) => {
    const cleanup = [];

    cleanup.push(
      PushNotifications.addListener("registration", async (token) => {
        try {
          await sendTokenToBackend(token.value);
          resolve({ ok: true, token: token.value });
        } catch (e) {
          resolve({ ok: false, reason: "backend-register-failed", error: e });
        }
      })
    );

    cleanup.push(
      PushNotifications.addListener("registrationError", (err) => {
        resolve({ ok: false, reason: "registration-error", error: err });
      })
    );

    PushNotifications.register().catch((err) => {
      resolve({ ok: false, reason: "register-call-failed", error: err });
    });
  });
}

async function sendTokenToBackend(token) {
  const auth =
    localStorage.getItem("access") ||
    localStorage.getItem("bearer") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token");
  if (!auth) return;
  const isJWT = !!localStorage.getItem("access");
  const authHeader = isJWT ? `Bearer ${auth}` : `Token ${auth}`;

  await fetch(apiUrl("/api/push/devices/"), {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: authHeader },
    body: JSON.stringify({ token, platform: platformName() }),
  });
}

export function onPushReceived(handler) {
  return PushNotifications.addListener("pushNotificationReceived", handler);
}

export function onPushActionPerformed(handler) {
  return PushNotifications.addListener("pushNotificationActionPerformed", handler);
}

/**
 * Auto-register the device for push if the user is logged in.
 *
 * Idempotent: Android remembers the user's previous permission answer,
 * so calling this on every app launch is safe. If denied previously,
 * registerForPush returns early without re-prompting.
 *
 * We gate on auth so logged-out users don't get prompted at the landing
 * page (which would be confusing — they have no context for why an app
 * they haven't signed into wants to push them).
 */
export async function maybeAutoRegister() {
  if (!isNative()) return;
  const hasAuth =
    localStorage.getItem("access") ||
    localStorage.getItem("bearer") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("token");
  if (!hasAuth) return;
  try {
    await registerForPush();
  } catch (e) {
    console.warn("maybeAutoRegister failed:", e);
  }
}
